import React from 'react'

import { Chip, ChipCount, ChipName, Chips, Label, Root } from './styled'

export default function CompetitorQuickFilters({ competitors, filters, formatCount, onFilterChange, t }) {
  return (
    <Root>
      <Label>{t('competitive_intelligence_research_by_competitor')}</Label>
      <Chips role="group" aria-label={t('competitive_intelligence_research_by_competitor')}>
        {competitors.map(competitor => (
          <Chip
            key={competitor.key}
            type="button"
            active={filters.competitor === competitor.key}
            aria-pressed={filters.competitor === competitor.key}
            onClick={() => onFilterChange('competitor', filters.competitor === competitor.key ? '' : competitor.key)}
          >
            <ChipName>{competitor.label}</ChipName>
            <ChipCount>{formatCount(competitor.count)}</ChipCount>
          </Chip>
        ))}
      </Chips>
    </Root>
  )
}
